exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-6aec8103]{position:relative}.elTabls[data-v-6aec8103]{width:100%}.leftDiv[data-v-6aec8103],.rightDiv[data-v-6aec8103]{-webkit-box-flex:1;-ms-flex:1;flex:1}.addButton[data-v-6aec8103]{position:absolute;z-index:1;top:-30px;right:50px}.tabsDiv[data-v-6aec8103]{margin-top:10px}", ""]);

// exports
